// Liste centralisée des rôles, utilisée par le select de filtre,
// les formulaires d'ajout et l'affichage des chips.
export const ROLE_OPTIONS = [
  { value: '1', label: 'Super Admin', bgcolor: '#EAE6FF', color: '#4318FF' },
  { value: '2', label: 'Admin', bgcolor: '#E6F9F0', color: '#05CD99' },
  { value: '3', label: 'Intervenant', bgcolor: '#FFF5E6', color: '#FFB547' },
  { value: '4', label: 'Praticien', bgcolor: '#E1F0FF', color: '#0075FF' },
];

export const getRoleInfo = (role) => {
  const found = ROLE_OPTIONS.find((r) => Number(r.value) === Number(role));
  if (found) return found;
  return { label: 'Membre', bgcolor: '#F4F7FE', color: '#2B3674' };
};
